{
  "verified": "Verificado",
  "iv_status": {
    "verified": "Verificado",
    "pending": "Pendente",
    "attention": "Atenção"
  },
  "zoom_in": "Ampliar",
  "zoom_out": "Reduzir o zoom",
  "rotate": "Rodar",
  "close": "Fechar",
  "esc_to_close": "Prima ESC para fechar",
  "play": "Jogar",
  "pause": "Pausa",
  "mute": "Sem som",
  "unmute": "Desativar o som",
  "enter_full_screen": "Entrar no ecrã inteiro",
  "exit_full_screen": "Sair do ecrã inteiro",
  "video_not_supported": "O seu browser não suporta a etiqueta de vídeo.",
  "skip_forward": "Saltar para a frente",
  "skip_backward": "Saltar para trás",
  "loading": "Carregamento",
  "loading_video": "A carregar vídeo...",
  "loading_data_description": "Aguarde enquanto carregamos os seus dados. Não vai demorar muito.",
  "no_results": "Sem resultados",
  "nothing_found": "Nada encontrado",
  "save_changes": "Guardar alterações",
  "saved_exclamation": "Salvo!",
  "saving": "Poupança",
  "validating": "A validar",
  "error": "Erro",
  "optional": "Opcional",
  "search_property": "Pesquisar imóveis",
  "reset_search": "Repor pesquisa",
  "no_items_to_show": "Não há itens para mostrar",
  "showing_range_of_total_items": "A mostrar {{range}} de {{total}} itens",
  "rows_per_page": "Linhas por página",
  "page_of_pages": "Página {{page}} de {{pages}}",
  "go_to_first_page": "Ir para a primeira página",
  "go_to_previous_page": "Ir para a página anterior",
  "go_to_next_page": "Ir para a página seguinte",
  "go_to_last_page": "Ir para a última página",
  "sort_in_asc": "Ordenar por ordem ascendente",
  "sort_in_desc": "Ordenar por ordem descendente",
  "clear_sorting": "Triagem clara",
  "sort_a_z": "Ordenar A → Z",
  "sort_z_a": "Ordenar Z → A",
  "reach_us_at_email": "Obter ajudaem support@chekin.com",
  "please_wait": "Aguarde",
  "feature_coming_soon": "Em breve",
  "feature_coming_soon_description": "Esta funcionalidade está atualmente em desenvolvimento e estará disponível em breve. Mantenha-se atualizado para as últimas notícias!",
  "beta": "Beta",
  "download_all": "Transferir tudo",
  "entry_forms": "Formulários de inscrição",
  "tutorial": "Tutorial",
  "liveness_video": "Vídeo de prova de vida",
  "reviews": "Comentários",
  "learn_more": "Saiba mais",
  "this_cannot_be_reverted": "This cannot be reverted",
  "delete": "Delete",
  "cancel": "Cancel",
  "you_have_made_changes": "You have made changes",
  "would_you_like_to_save_them": "Would you like to save them?",
  "save": "Save",
  "dont_save": "Don't save",
  "copied_exclamation": "Copiado!",
  "search_placeholder": "Procurar...",
  "type_to_search": "Digite para pesquisar...",
  "loading_more": "Carregando...",
  "no_options": "Sem opções",
  "select_option": "Selecionar opção",
  "clear_all": "Limpar tudo",
  "remove_item": "Remover {{label}}",
  "upload_file": "Carregar ficheiro",
  "download_attachment": "Descarregar anexo",
  "remove_file": "Remover ficheiro",
  "open_calendar": "Calendário aberto",
  "clear_dates": "Limpar datas",
  "select_dates": "Selecionar datas",
  "pick_date_range": "Selecionar um intervalo de datas",
  "from": "De",
  "to": "Para",
  "pick_month": "Escolher um mês",
  "pick_date": "Escolher uma data",
  "month": "Mês",
  "day": "Dia",
  "year": "Ano",
  "done": "Feito",
  "wrong_period_of_dates": "O período selecionado é inválido",
  "date_range_max_days_error_one": "O intervalo não pode exceder {{count}} dia",
  "date_range_max_days_error_other": "O intervalo não pode exceder {{count}} dias",
  "date_range_min_days_error_one": "O intervalo deve ser de, pelo menos, {{count}} dia",
  "date_range_min_days_error_other": "O intervalo deve ser de, pelo menos, {{count}} dias",
  "past_dates": "A data não pode ser anterior a {{minDate}}",
  "future_dates": "A data não pode ser posterior a {{maxDate}}",
  "signature_placeholder_text": "Assina dentro desta caixa.<br/> Utiliza o teu dedo.<br/> Toca para começar.",
  "open_devices_camera": "Abrir a câmara do dispositivo",
  "place_document_inside_frame": "Coloque o seu documento dentro da moldura",
  "close_other_application_that_may_be_using_your_camera": "Fechar outras aplicações que possam estar a utilizar a sua câmara",
  "if_you_use_external_camera_disconnect_and_reconnect": "Se utilizar uma câmara externa, desligue-a e volte a ligá-la",
  "close_the_browser_re_open_it": "Fechar o browser e voltar a abri-lo",
  "camera_errors": {
    "experiencing_camera_issues": "Está a ter problemas com a câmara?",
    "chekin_cant_use_your_camera": "Chekin não pode usar a sua câmara",
    "please_try_a_different_browser": "A sua câmara não funciona neste browser. Tente abrir a ligação noutro browser.",
    "permissions_denied": "Permissão negada",
    "camera_permissions_denied": "A câmara não abre? Certifique-se de que dá permissão ao browser para utilizar a câmara.",
    "no_camera_device_found": "Não foi encontrado nenhum dispositivo de câmara. Ligue uma câmara.",
    "constraints_camera_error": "As restrições não podem ser satisfeitas pelos dispositivos disponíveis.",
    "safari_camera_error": "O Safari não conseguiu satisfazer os requisitos da câmara",
    "try_chrome_or_firefox": "Experimente o Chrome ou o Firefox"
  },
  "clear": "Limpo",
  "show_less": "Mostrar menos",
  "show_more": "Mostrar mais",
  "tap_here_to_sign": "Toque aqui para assinar",
  "click_here_to_sign": "Clique aqui para assinar",
  "prefix": "Prefixo",
  "prefix_required": "O prefixo é obrigatório",
  "reset": "Reiniciar",
  "show_password": "Mostrar palavra-passe",
  "hide_password": "Ocultar palavra-passe",
  "increment": "Incremento",
  "decrement": "Diminuição",
  "create_option": "Criar \"{{input}}\"",
  "year_out_of_range": "O ano deve estar compreendido entre {{min}} e {{max}}",
  "clear_date": "Limpar data",
  "select_date": "Selecionar data",
  "draw_signature_here": "Assine aqui",
  "signature_hint": "Use o rato ou o dedo",
  "clear_signature": "Assinatura nítida",
  "draw_signature_here_mobile": "Assine com a sua assinatura",
  "signature_hint_mobile": "Usa o dedo",
  "camera_access_needed": "É necessário acesso à câmara",
  "camera_access_needed_text": "Permita o acesso à câmara para tirar a fotografia. Se estiver bloqueado, ative a câmara nas definições do seu navegador e, em seguida, tente novamente.",
  "dialog": "Diálogo"
}
